import { formatDateWithTime } from 'Shared/utils';
import { GetSignaturePacketSendAttemptResposne } from './types';
import { DateTime } from 'luxon';

export const transformGetSignaturePacketResponse = (
  response: GetSignaturePacketSendAttemptResposne
): GetSignaturePacketSendAttemptResposne => {
  return {
    ...response,
    triggered_at: formatDateWithTime(
      response.triggered_at,
      DateTime.now().zone.name
    ),
  };
};
